/* eslint-disable no-param-reassign */
import {
  PlatformLastHealthStatusEnum,
  PlatformLastHealthStatusTypes,
  PlatformStatusEnum,
  PlatformStatusTypes,
} from "@hooks/dtos/IPlatformDTO";
import { config } from "config";
import { FaCheckCircle, FaTimes, FaTimesCircle, FaTrashAlt } from "react-icons/fa";
import { FaPowerOff, FaTrash } from "react-icons/fa6";
import { FiAlertCircle, FiWifiOff } from "react-icons/fi";

export interface IPlatformHealthStatusInfoDTO {
  badge: "success" | "danger" | "warning";
  icon: React.ComponentType<{
    size?: number;
    className?: string;
  }>;
  logo: string;
  text: string;
}

export interface IPlatformStatusInfoDTO {
  color: "success" | "danger" | "warning";
  icon: React.ComponentType<{
    size?: number;
    className?: string;
  }>;
  text: string;
}

export const getPlatformStatusInfo = (
  status: PlatformStatusTypes
): IPlatformStatusInfoDTO => {
  switch (status) {
    default:
    case PlatformStatusEnum.ACTIVE:
      return {
        color: "success",
        icon: FaCheckCircle,
        text: "Ativo",
      };
    case PlatformStatusEnum.INACTIVE:
      return {
        color: "danger",
        icon: FaTimesCircle,
        text: "Desativado",
      };
    case PlatformStatusEnum.DELETED:
      return {
        color: "danger",
        icon: FaPowerOff,
        text: "Excluído",
      };
  }
};

export const getPlatformLastHealthStatusInfo = (
  platformId: number,
  lastHealthCheck: PlatformLastHealthStatusTypes
): IPlatformHealthStatusInfoDTO => {
  // --- Load the Appropriate Logo --- //
  const logo = getPlatformLogoById(platformId);

  switch (lastHealthCheck) {
    case PlatformLastHealthStatusEnum.ONLINE:
      return {
        badge: "success",
        icon: FaCheckCircle,
        logo,
        text: "Online",
      };
    case PlatformLastHealthStatusEnum.OFFLINE:
      return {
        badge: "danger",
        icon: FiWifiOff,
        logo,
        text: "Offline",
      };
    case PlatformLastHealthStatusEnum.DEGRADED:
      return {
        badge: "warning",
        icon: FiAlertCircle,
        logo,
        text: "Lentidão",
      };
    default:
      return {
        badge: "danger",
        icon: FiWifiOff,
        logo,
        text: "Offline",
      };
  }
};

export const getPlatformLogoById = (platformId: number): string => {
  let logo: string;
  switch (platformId) {
    case 1: // Cannabis & Saúde
      logo = config.logos.ces;
      break;

    case 2: // TegraPharma
      logo = config.logos.tegra;
      break;

    case 3: // TegraPharma Corp
      logo = config.logos.tegracorp;
      break;

    case 4: // Vigo Academy
      logo = config.logos.vigo;
      break;

    case 5: // Consultando em 321
      logo = config.logos.ces;
      break;

    case 6: // Odonto Cannabis Summit
      logo = config.logos.odontocansummit;
      break;

    case 7: // Consulta CS
      logo = config.logos.ces;
      break;

    case 8: // CanteraMed
      logo = config.logos.ces;
      break;

    default:
      logo = config.logos.default;
      break;
  }

  return logo;
};
